import { Worker } from "types/generated";
import {
  BulkActionActionConfirmationTabs,
  BulkActionItemID,
  BulkActionsStep,
  BulkActionsVariant,
} from "components/BulkActions/types";
import BulkActionsDrawerActionStepsFooter from "components/BulkActions/Drawer/ActionSteps/Footer";
import BulkActionsDrawerActionStepsConfirmation from "components/BulkActions/Drawer/ActionSteps/Confirmation";
import BulkActionsDrawerActionStepsConfirmationEmptyTab from "components/BulkActions/Drawer/ActionSteps/Confirmation/EmptyTab";

import {
  PrivateWorkerPoolWorkersBulkActionsAnalyticsPayload,
  PrivateWorkerPoolWorkersBulkActionsSelectedAction,
} from "./types";
import PrivateWorkerPoolWorkersBulkActionsSelectedItem from "./SelectedItem";
import PrivateWorkerPoolWorkersBulkActionsConfirmActionForm from "./ConfirmActionForm";

type PrivateWorkerPoolWorkersBulkActionsConfirmationViewProps = {
  applicableItems: Worker[];
  skippedItems: Worker[];
  onItemDismiss: (id: BulkActionItemID) => void;
  selectedBulkAction: PrivateWorkerPoolWorkersBulkActionsSelectedAction;
  onConfirm: (analyticsPayload: PrivateWorkerPoolWorkersBulkActionsAnalyticsPayload) => void;
  onCancel: () => void;
};

const PrivateWorkerPoolWorkersBulkActionsConfirmationView = ({
  applicableItems,
  skippedItems,
  onItemDismiss,
  selectedBulkAction,
  onConfirm,
  onCancel,
}: PrivateWorkerPoolWorkersBulkActionsConfirmationViewProps) => {
  const getItems = (tab: BulkActionActionConfirmationTabs) => {
    if (tab === BulkActionActionConfirmationTabs.Applicable) {
      return applicableItems;
    }

    return skippedItems;
  };

  return (
    <>
      <BulkActionsDrawerActionStepsConfirmation
        applicableCount={applicableItems.length}
        skippedCount={skippedItems.length}
      >
        {({ currentTab }) =>
          getItems(currentTab).length === 0 ? (
            <BulkActionsDrawerActionStepsConfirmationEmptyTab currentTab={currentTab} />
          ) : (
            getItems(currentTab).map((item) => (
              <PrivateWorkerPoolWorkersBulkActionsSelectedItem
                key={item.id}
                item={item}
                onDismiss={onItemDismiss}
                step={BulkActionsStep.ActionConfirmation}
              />
            ))
          )
        }
      </BulkActionsDrawerActionStepsConfirmation>

      <BulkActionsDrawerActionStepsFooter>
        <PrivateWorkerPoolWorkersBulkActionsConfirmActionForm
          variant={BulkActionsVariant.Drawer}
          action={selectedBulkAction}
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </BulkActionsDrawerActionStepsFooter>
    </>
  );
};

export default PrivateWorkerPoolWorkersBulkActionsConfirmationView;
